import { resetAIState, selectHasActiveSmartPreferences, type JourneyLeg } from '@/src/redux/slices/aiRecommendationSlice'
import { useAppDispatch, useAppSelector } from '@/src/redux/store'
import { DEFAULT_WEIGHTS } from '@/src/utils/srp/aiRecommendation/metrics'
import { useCallback } from 'react'
import { useClearFilters } from '../clearFilters'
import useUpdateSearchResultCache from '../updateSearchResultCache'
import useSearchResults from '../useSearchResults'

export function useResetSmartPreferences () {
    const dispatch = useAppDispatch()
    const { selectedJourneyLeg } = useSearchResults()
    const leg = selectedJourneyLeg as JourneyLeg
    const hasActivePreferences = useAppSelector(state => selectHasActiveSmartPreferences(state, leg))
    const updateCache = useUpdateSearchResultCache()
    const { handleClearAllFilters } = useClearFilters()

    const resetSmartPreferences = useCallback(() => {
        if (!hasActivePreferences) return

        updateCache(currentData => {
            if (!currentData?.smartRecommendationData) return currentData as NonNullable<typeof currentData>
            const data = currentData
            data.smartRecommendationData[leg].suggestedFilters = null
            data.smartRecommendationData[leg].weights = DEFAULT_WEIGHTS
            data.smartRecommendationData[leg].preferences = null
            data.smartRecommendationData[leg].priority = null
            return data as NonNullable<typeof currentData>
        })

        handleClearAllFilters()
        dispatch(resetAIState(leg))
    }, [hasActivePreferences, leg, updateCache, handleClearAllFilters, dispatch])

    return { resetSmartPreferences, hasActivePreferences }
}
